import { render, staticRenderFns } from "./ejdwWanchengduBarChart.vue?vue&type=template&id=0bb9ffb4&scoped=true"
import script from "./ejdwWanchengduBarChart.vue?vue&type=script&lang=js"
export * from "./ejdwWanchengduBarChart.vue?vue&type=script&lang=js"
import style0 from "./ejdwWanchengduBarChart.vue?vue&type=style&index=0&id=0bb9ffb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9ffb4",
  null
  
)

export default component.exports